export const directoryLogoPath: string = '/Blob/images/brands'
export const defaultLogoPath: string = `${directoryLogoPath}/logo.webp`
export const mapBrands: Map<string, string> = new Map([
    ['ingeus', 'webp'],
])